import { memo, useMemo, useState } from 'react';
import { Grid } from '@mui/material';
import Table from 'shell/components/shared/table-person';
import { headCellsFamilyFunc } from './constants';
import { FamilyVM } from 'shell/view-models/family';
import { useUserProfile } from 'shell/hooks/use-user-profile';

interface TableFamilyProps {
  data?: Array<FamilyVM>;
}

const TableFamilyComponent = ({ data = [] }: TableFamilyProps): React.ReactElement => {
  const [family] = useState(data);

  const { userProfile } = useUserProfile();

  const body = useMemo(() => {
    return family.map((item) => {
      return {
        ...item,
      };
    });
  }, [family]);

  const headCellsFamily = useMemo(() => {
    return headCellsFamilyFunc(userProfile);
  }, [userProfile]);

  return body.length > 0 ? (
    <Grid container item spacing={2}>
      <Grid item xs={12}>
        <Table head={headCellsFamily} body={body} ariaLabel="Lista Famiglia" minWidth={1300} />
      </Grid>
    </Grid>
  ) : (
    <></>
  );
};

TableFamilyComponent.displayName = 'Family step component';

const TableFamily = memo(TableFamilyComponent);

export default TableFamily;
